/**
 * Quick-Navigation auf Kollektionsseiten (blocks/cc-quicknav.liquid).
 * - Layout „more“ (Desktop): Kategorien auf eine Zeile kürzen, Rest hinter „+ n weitere“.
 *   Die aktive Kategorie bleibt immer sichtbar.
 * - Mobil mit Scroll-Zeile: aktive Schaltfläche (nur so weit wie nötig) in den sichtbaren Bereich schieben.
 * Wird als normales (blockierendes) Skript direkt nach der Leiste geladen, damit sie schon vor dem ersten
 * Zeichnen gekürzt ist – daher alles in einem Block, falls die Leiste mehrfach auf der Seite steht.
 */
if (!customElements.get('cc-quicknav')) {
const desktop = window.matchMedia('(min-width: 750px)');

class CcQuicknav extends HTMLElement {
  #list = null;
  #more = null;
  #button = null;
  #expanded = false;
  #observer = null;

  connectedCallback() {
    this.#list = this.querySelector('.cc-quicknav__list');
    this.#more = this.querySelector('.cc-quicknav__more');
    this.#button = this.querySelector('.cc-quicknav__more-button');
    if (!this.#list) return;

    this.#button?.addEventListener('click', this.#toggle);
    desktop.addEventListener('change', this.#update);
    this.#observer = new ResizeObserver(this.#update);
    this.#observer.observe(this.#list);
    this.#update();
    this.dataset.ready = '';
    this.#scrollToActive();
    // nach dem Laden der Webfont neu messen (Schaltflächen werden breiter/schmaler)
    document.fonts?.ready.then(this.#update);
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#toggle);
    desktop.removeEventListener('change', this.#update);
    this.#observer?.disconnect();
  }

  get #categories() {
    return [...this.#list.querySelectorAll('.cc-quicknav__item--category')];
  }

  #toggle = () => {
    this.#expanded = !this.#expanded;
    this.#update();
  };

  #update = () => {
    const items = this.#categories;
    items.forEach((item) => (item.hidden = false));

    if (this.dataset.layout !== 'more' || !desktop.matches || !this.#more || items.length === 0) {
      if (this.#more) this.#more.hidden = true;
      return;
    }

    this.#more.hidden = false;
    if (this.#expanded) {
      this.#setLabel(this.#button.dataset.labelLess);
      return;
    }

    // Von hinten ausblenden, bis „Weitere“ in der ersten Kategorie-Zeile steht
    const firstLine = items[0].offsetTop;
    for (let i = items.length - 1; i >= 0 && this.#more.offsetTop > firstLine; i--) {
      if (items[i].querySelector('[aria-current]')) continue;
      items[i].hidden = true;
    }

    const hiddenCount = items.filter((item) => item.hidden).length;
    this.#more.hidden = hiddenCount === 0;
    this.#setLabel(this.#button.dataset.labelMore.replace('[n]', hiddenCount));
  };

  #setLabel(label) {
    this.#button.textContent = label;
    this.#button.setAttribute('aria-expanded', String(this.#expanded));
  }

  #scrollToActive() {
    if (desktop.matches || !this.hasAttribute('data-scroll-to-active')) return;
    const active = this.#list.querySelector('[aria-current]')?.closest('li');
    if (!active || this.#list.scrollWidth <= this.#list.clientWidth) return;
    // nur so weit scrollen, dass die aktive Schaltfläche ganz sichtbar ist – der Anfang der Leiste bleibt möglichst im Bild
    const margin = parseFloat(getComputedStyle(this.#list).paddingLeft);
    const overflow = active.offsetLeft + active.offsetWidth + margin - this.#list.clientWidth;
    if (overflow > 0) this.#list.scrollLeft = overflow;
  }
}

customElements.define('cc-quicknav', CcQuicknav);
}
